import axios from "axios";

// Use production API URL when deployed, localhost for development
const baseURL = process.env.NODE_ENV === 'production' 
  ? 'https://us-central1-aquatrio-support.cloudfunctions.net/api/api'
  : 'http://localhost:3001/api';

// Create axios instance
const http = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json" 
  }
});

// Add request interceptor to include auth token
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default http;